// Theme utilities
export const THEME_STORAGE_KEY = 'theme'

export const themes = {
  light: 'light',
  dark: 'dark'
}

/**
 * Get current theme from localStorage or default to light
 * @returns {string} Current theme
 */
export function getCurrentTheme() {
  return localStorage.getItem(THEME_STORAGE_KEY) || themes.light
}

/**
 * Set theme and save to localStorage
 * @param {string} theme - Theme to set
 */
export function setTheme(theme) {
  if (!Object.values(themes).includes(theme)) {
    console.warn(`Invalid theme: ${theme}`)
    return
  }
  
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem(THEME_STORAGE_KEY, theme)
}

/**
 * Toggle between light and dark themes
 * @returns {string} New theme
 */
export function toggleTheme() {
  const currentTheme = getCurrentTheme()
  const newTheme = currentTheme === themes.light ? themes.dark : themes.light
  setTheme(newTheme)
  return newTheme
}

/**
 * Initialize theme on app startup
 */
export function initializeTheme() {
  const savedTheme = getCurrentTheme()
  setTheme(savedTheme)
}

/**
 * Check if current theme is dark
 * @returns {boolean}
 */
export function isDarkTheme() {
  return getCurrentTheme() === themes.dark
}

/**
 * Check if current theme is light
 * @returns {boolean}
 */
export function isLightTheme() {
  return getCurrentTheme() === themes.light
} 